import React, { useState } from "react";
// import RoomBookingTable from "./Components/RoomBookingTable";
// import { useDispatch} from "react-redux"
import { useLocation, useNavigate } from "react-router-dom";
import ReportsMainTable from "./Components/ReportsMainTable";

const ReportsMainList = () => {
  // const dispatch = useDispatch()
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedCategory, setSelectedCategory] = useState();

  return (
    <>
      <div className="px-xl-5 px-lg-4 px-3 py-3 page-body">
        <div className="row g-3">
          <div className="col-sm-12">
            <div className="d-flex align-items-center justify-content-between flex-wrap">
              <h3 className="fw-bold mb-0">Reports Main List</h3>
              <div className="col-auto d-flex w-sm-100"></div>
            </div>
          </div>
          <div className="col-sm-12 ">
            <div className="card">
              <div className="card-body ">
                <ReportsMainTable setSelectedCategory={setSelectedCategory} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default ReportsMainList;
